export default __webpack_public_path__ + "static/media/exclametry_red_dark.e13c06f2.svg";